/**
 * Single in-code source for the canonical genre taxonomy.
 *
 * Mirrors data/genres/spotify-genre-fold.json, which also seeds
 * genres_canonical + spotify_genre_map via
 * supabase/migrations/20260821100000_genre_canonical_fold.sql. The live DB
 * remains the runtime authority; this module exists for static UI (mega menu,
 * catalogs) that renders without a fetch.
 */
import foldData from '../../data/genres/spotify-genre-fold.json';

export type CanonicalGenreDef = {
  slug: string;
  name: string;
  category: string;
  featured: boolean;
  sort_order: number;
};

/** Ordered by sort_order (matches the genres_canonical seed). */
export const CANONICAL_GENRES: CanonicalGenreDef[] = [...foldData.canonical]
  .sort((a, b) => a.sort_order - b.sort_order);

export const CANONICAL_GENRE_SLUGS: string[] = CANONICAL_GENRES.map((genre) => genre.slug);

export const CANONICAL_GENRE_NAMES: string[] = CANONICAL_GENRES.map((genre) => genre.name);

/** Display name for a canonical slug, or the input when unknown. */
export function canonicalGenreName(slug: string): string {
  return CANONICAL_GENRES.find((genre) => genre.slug === slug)?.name ?? slug;
}
